import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const FolderType = iotsUtils.fromList(constants.folder.folderType.ids);
